// extracted by mini-css-extract-plugin
export default {"modal":"CandidateManagementModal-module__modal__ZC9rj","content":"CandidateManagementModal-module__content__8gXXz"};